import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'formattedDate',
  standalone: true,
})
export class FormattedDatePipe implements PipeTransform {
  private readonly datePipe = new DatePipe('en-US');

  transform(value?: Date | string | null): string | null {
    if (!value) {
      return '-';
    }

    try {
      const date = new Date(value);
      return this.datePipe.transform(date, 'MM/dd/yyyy');
    } catch (e) {
      return value as string;
    }
  }
}
